import React from 'react';
import { Quote } from 'lucide-react';
import { Card } from './ui/card';

const TestimonialsSection = () => {
  const row1Testimonials = [
    {
      name: 'Kirti',
      location: 'HAL 2nd Stage',
      review:
        "I was honestly surprised how fast my order came. Ordered in the morning and had it within a few minutes. Plus the products actually matched my skin concerns instead of generic recommendations.",
      image: 'https://images.unsplash.com/photo-1670890017917-837ee6e72855?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBtaWxsZW5uaWFsJTIwY2FzdWFsJTIwdHNoaXJ0JTIwcG9ydHJhaXQlMjBzbWlsZXxlbnwwfHx8fDE3NzAxOTYzNjR8MA&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Neha',
      location: 'Domlur',
      review:
        "What I liked most was that decimal didn't just push expensive products. It asked about my skin and suggested what made sense. Delivery was super quick too.",
      image: 'https://images.unsplash.com/photo-1618919306916-94a2098b21b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxicm93biUyMHNraW4lMjB3b21hbiUyMHNtaWxpbmclMjBjYXN1YWwlMjBjbG90aGVzfGVufDB8fHx8MTc3MDE5NjMyM3ww&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Pradnyesh',
      location: '100ft Road',
      review:
        "I've tried many skincare apps but this felt more thoughtful. They understood my oily + acne-prone skin and I got my routine the same day.",
      image: 'https://images.unsplash.com/photo-1717671999799-d1af89214016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBtaWxsZW5uaWFsJTIwY2FzdWFsJTIwdHNoaXJ0JTIwcG9ydHJhaXQlMjBzbWlsZXxlbnwwfHx8fDE3NzAxOTYzNjR8MA&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Ridhi',
      location: '80ft Road',
      review:
        "My skin is sensitive and I'm always scared to try new products. The quiz actually picked things that didn't irritate my skin. Huge relief.",
      image: 'https://images.unsplash.com/photo-1464892216009-6d356060e72c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx5b3VuZyUyMHdvbWFuJTIwYnJvd24lMjBza2luJTIwc21pbGUlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDE5NjM1Mnww&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
  ];

  const row2Testimonials = [
    {
      name: 'Ritika',
      location: 'Defence Colony',
      review:
        "It felt like someone actually listened to my skin problems instead of giving a one-size-fits-all routine. And yes, delivery was insanely fast.",
      image: 'https://images.unsplash.com/photo-1709202967828-e1a7823ccdf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHdvbWFuJTIwYnJvd24lMjBza2luJTIwc21pbGUlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDE5NjM1Mnww&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Sameer',
      location: 'Kodihalli',
      review:
        "Finally a skincare platform that understands Indian skin and weather. The recommendations were spot on and delivery was quick.",
      image: 'https://images.unsplash.com/photo-1768696082477-935267948a2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxzb3V0aCUyMGFzaWFuJTIwbWFuJTIwY2FzdWFsJTIwc21pbGUlMjBwb3J0cmFpdCUyMG91dGRvb3JzfGVufDB8fHx8MTc3MDE5NjMzM3ww&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Karishma',
      location: 'HAL 1st Stage',
      review:
        "Loved how simple the process was. Took a picture, got a routine, and it arrived the same day. My skin already feels calmer.",
      image: 'https://images.unsplash.com/photo-1607842858972-a9352fbd13c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxicm93biUyMHNraW4lMjB3b21hbiUyMHNtaWxpbmclMjBjYXN1YWwlMjBjbG90aGVzfGVufDB8fHx8MTc3MDE5NjMyM3ww&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
    {
      name: 'Arjun',
      location: 'Jeevanbimanagar',
      review:
        "The best part was not having to research endlessly. Decimal figured out what my skin needed and sent it quickly. Saved me so much time.",
      image: 'https://images.unsplash.com/photo-1749234771277-d5ed143bdf7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBtaWxsZW5uaWFsJTIwY2FzdWFsJTIwdHNoaXJ0JTIwcG9ydHJhaXQlMjBzbWlsZXxlbnwwfHx8fDE3NzAxOTYzNjR8MA&ixlib=rb-4.1.0&q=85&w=150&h=150&fit=crop',
    },
  ];

  const TestimonialCard = ({ testimonial }) => (
    <Card className="flex-shrink-0 w-80 p-6 bg-gradient-to-br from-brand-50 to-white hover:shadow-xl transition-all duration-300 relative border-2 hover:border-brand-300">
      <div className="absolute top-4 left-4 text-brand-500 opacity-30">
        <Quote className="w-8 h-8" />
      </div>
      <div className="flex items-center gap-4 mb-4 mt-6">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover border-2 border-brand-200"
        />
        <div>
          <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
          <p className="text-sm text-gray-500">{testimonial.location}</p>
        </div>
      </div>
      <p className="text-gray-700 leading-relaxed text-sm">{testimonial.review}</p>
    </Card>
  );

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-brand-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-brand-100 px-4 py-2 rounded-full mb-4">
            <div className="w-2 h-2 bg-brand-600 rounded-full"></div>
            <span className="text-brand-700 font-medium">Our Testimonials</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            User reviews and feedback
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See how decimal has transformed users' experiences through their own words
          </p>
        </div>

        {/* Row 1 - Scroll Left to Right */}
        <div className="relative mb-6">
          <div className="flex gap-6 animate-scroll-left">
            {[...row1Testimonials, ...row1Testimonials, ...row1Testimonials, ...row1Testimonials].map((testimonial, index) => (
              <TestimonialCard key={`row1-${index}`} testimonial={testimonial} />
            ))}
          </div>
        </div>

        {/* Row 2 - Scroll Right to Left */}
        <div className="relative">
          <div className="flex gap-6 animate-scroll-right">
            {[...row2Testimonials, ...row2Testimonials, ...row2Testimonials, ...row2Testimonials].map((testimonial, index) => (
              <TestimonialCard key={`row2-${index}`} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
